import { render, staticRenderFns } from "./index.vue?vue&type=template&id=220c8dc6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=220c8dc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c8dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('220c8dc6')) {
      api.createRecord('220c8dc6', component.options)
    } else {
      api.reload('220c8dc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=220c8dc6&scoped=true", function () {
      api.rerender('220c8dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/report/dashboard/index.vue"
export default component.exports